import { IAction } from "../../../interface/action.interface";
import { IListDto } from "../../../interface/dto/list.dto";
import { ITrackedList } from "../../tracked-lists/interface/dto/tracked-lists.dto";

export enum ListBuilderListActionType {
    LIST_BUILDER_LIST_INIT = "LIST_BUILDER_LIST_INIT",
    LIST_BUILDER_LIST_GET = "LIST_BUILDER_LIST_GET",
    LIST_BUILDER_LIST_SUCCESS = "LIST_BUILDER_LIST_SUCCESS",
    LIST_BUILDER_LIST_ERROR = "LIST_BUILDER_LIST_ERROR",
    LIST_BUILDER_LIST_GET_TRACKED_LISTS = "LIST_BUILDER_LIST_GET_TRACKED_LISTS",
    LIST_BUILDER_LIST_GET_TRACKED_LISTS_NEXT_PAGE = "LIST_BUILDER_LIST_GET_TRACKED_LISTS_NEXT_PAGE",
    LIST_BUILDER_LIST_GET_TRACKED_LISTS_SUCCESS = "LIST_BUILDER_LIST_GET_TRACKED_LISTS_SUCCESS",
    LIST_BUILDER_LIST_GET_TRACKED_LISTS_ERROR = "LIST_BUILDER_LIST_GET_TRACKED_LISTS_ERROR",
}

export interface IListBuilderListInitAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_INIT;
}

export interface IListBuilderListGetAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET;
}

export interface IListBuilderListSuccessAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_SUCCESS;
    payload: {
        lists: Array<IListDto>;
    };
}

export interface IListBuilderListErrorAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_ERROR;
    payload: {
        error: string;
    };
}

export interface IListBuilderListGetTrackedListsAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS;
}

export interface IListBuilderListGetTrackedListsNextPageAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_NEXT_PAGE;
    payload: {
        trackedLists: Array<ITrackedList> | null;
        offset: number;
        total: number | null;
    };
}

export interface IListBuilderListGetTrackedListsSuccessAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_SUCCESS;
}

export interface IListBuilderListGetTrackedListsErrorAction extends IAction {
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_ERROR;
    payload: {
        error: string;
    };
}

export const listBuilderListInitAction = () => ({
    type: ListBuilderListActionType.LIST_BUILDER_LIST_INIT,
    payload: {},
});

export const listBuilderListGetAction = (): IListBuilderListGetAction => ({
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET,
    payload: {},
});

export const listBuilderListSuccessAction = (
    lists: Array<IListDto>,
): IListBuilderListSuccessAction => ({
    type: ListBuilderListActionType.LIST_BUILDER_LIST_SUCCESS,
    payload: { lists },
});

export const listBuilderListErrorAction = (
    error: string,
): IListBuilderListErrorAction => ({
    type: ListBuilderListActionType.LIST_BUILDER_LIST_ERROR,
    payload: { error },
});

export const listBuilderListGetTrackedListsAction = () => ({
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS,
    payload: {},
});

export const listBuilderListGetTrackedListsNextPageAction = (
    trackedLists: Array<ITrackedList> | null,
    offset: number,
    total: number | null,
): IListBuilderListGetTrackedListsNextPageAction => ({
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_NEXT_PAGE,
    payload: { trackedLists, offset, total },
});

export const listBuilderListGetTrackedListsSuccessAction =
    (): IListBuilderListGetTrackedListsSuccessAction => ({
        type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_SUCCESS,
        payload: {},
    });

export const listBuilderListGetTrackedListsErrorAction = (
    error: string,
): IListBuilderListGetTrackedListsErrorAction => ({
    type: ListBuilderListActionType.LIST_BUILDER_LIST_GET_TRACKED_LISTS_ERROR,
    payload: { error },
});

export type IListBuilderListActions =
    | IListBuilderListInitAction
    | IListBuilderListGetAction
    | IListBuilderListSuccessAction
    | IListBuilderListErrorAction
    | IListBuilderListGetTrackedListsAction
    | IListBuilderListGetTrackedListsNextPageAction
    | IListBuilderListGetTrackedListsSuccessAction
    | IListBuilderListGetTrackedListsErrorAction;
